import { useMcpConnection } from "@/modules/ai/widgets/mcp-connection/model/use-mcp-connection";
import { McpConnectionView } from "@/modules/ai/widgets/mcp-connection/ui/mcp-connection-view";

export function McpConnection() {
  const connection = useMcpConnection();

  return <McpConnectionView {...connection} />;
}
